import { render, staticRenderFns } from "./FavouriteToggle.vue?vue&type=template&id=c1923386"
import script from "./FavouriteToggle.vue?vue&type=script&lang=js"
export * from "./FavouriteToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports